import { ContextBubble, IContextBubbleProps } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { containerSmall, containerTall } from 'styles/layout';
import { description, eyebrowThin, input } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface IContextBubbleStyledProps {
  hasStreet2: boolean;
}

export const FormGroup = styled.div`
  ${containerTall}
`;

export const Buttons = styled.div`
  ${containerSmall}

  margin-top: 13px;
`;

export const Container = styled.div`
  ${containerSmall}

  margin-top: 18px;
  text-align: left;
`;

export const MutedContainer = styled.div`
  ${({ theme }: IWithThemeProps) => `
    background-color: ${theme.bottomBackgroundMuted};
    border-radius: 6px;
    line-height: 1;
    margin: 15px 0 0;
    padding: 13px;
    position: relative;
  `}
`;

export const Subhead = styled.h2`
  ${eyebrowThin}

  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}

  ${large`
    margin: 0 0 0 -32px;
  `}
`;

export const SubheadText = styled.span`
  display: inline-block;
  margin-left: 7px;
`;

export const SubheadMuted = styled.h3`
  ${eyebrowThin}

  margin: 0;
  opacity: 0.8;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const Description = styled.p`
  ${description}

  margin: 3px 0 0 32px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}

  ${large`
    margin: 3px 0 0;
  `}
`;

export const Address = styled.p`
  ${input}

  margin: 7px 0 11px;
  opacity: 0.8;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

const ContextBubbleWithProps = ({
  hasStreet2: _hasStreet2,
  ...props
}: IContextBubbleStyledProps & IContextBubbleProps) => {
  return <ContextBubble {...props} />;
};

export const ContextBubbleStyled = styled(
  ContextBubbleWithProps,
)<IContextBubbleStyledProps>`
  left: 0;
  width: 100%;

  ${({ hasStreet2 }) => `
    bottom: ${hasStreet2 ? 165 : 140}px;
  `}

  ${large`
    left: 61px;
    width: 330px;
  `}
`;
